var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeftMobile = function SvgLeftMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.841 19.274a.73.73 0 0 0 1.056 0 .769.769 0 0 0 0-1.064l-5.353-5.45h14.499c.411 0 .957-.334.957-.754 0-.419-.546-.763-.957-.763H5.544L10.897 5.8a.782.782 0 0 0 0-1.075.73.73 0 0 0-1.056 0l-6.62 6.741a.75.75 0 0 0 0 1.065l6.62 6.742z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
};
export default SvgLeftMobile;